import dayjs from 'dayjs';
import { da } from 'vuetify/es5/locale';
export default {
    // ======================= COMMON =========================

    SET_APP_MENU(state, data) {
        state.appMenu = data;
    },
    SET_APPL_YMD(state, data) {
        state.applYmd = data;
    },
    SET_REQ_S_HM(state, data) {
        state.reqSHm = data;
    },
    SET_REQ_E_HM(state, data) {
        state.reqEHm = data;
    },
    SET_REQUEST_HOUR(state, data) {
        state.requestHour = data;
    },
    SET_S_YMD(state, data) {
        state.sYmd = data;
    },
    SET_E_YMD(state, data) {
        state.eYmd = data;
    },
    SET_APPL_CD(state, data) {
        state.applCd = data;
    },
    SET_REASON(state, reason) {
        state.reason = reason;
    },

    SET_REASON_FLAG(state, reasonFlag) {
        state.reasonFlag = reasonFlag;
    },
    // ======================= ATTEND =======================
    SET_ATTEND_PARAM(state) {
        state.attendParam = {
            bfShm: state.bfShm,
            bfEhm: state.bfEhm,
            afShm: state.reqSHm,
            afEhm: state.reqEHm,
            workYmd: state.workYmd,
            workWeek: state.workWeek,
            reason: state.reason,
        };
    },
    SET_BEFORE_START_HM(state, data) {
        state.bfShm = data;
    },
    SET_BEFORE_END_HM(state, data) {
        state.bfEhm = data;
    },
    // ======================= REWARD =======================
    SET_REWARD_PARAM(state) {
        state.rewardParam = {
            gntCd: state.gntCd.code,
            sYmd: state.sYmd,
            sYmdWeek: state.sYmdWeek,
            eYmd: state.eYmd,
            eYmdWeek: state.eYmdWeek,
            holDay: state.holDay,
            closeDay: state.closeDay,
            requestHour: state.requestHour,
            reason: state.reason,
            // mergeRows: state.rewardList,
        };
    },

    SET_REWARD_LIST(state, data) {
        state.rewardList = data;
    },
    SET_USE_REWARD_LIST(state, data) {
        state.useRewardList = data;
    },
    SET_REQ_TIME(state, data) {
        state.reqTime = data;
    },
    // ======================= SCHEDULE =======================
    SET_SCHEDULE_PARAM(state) {
        state.scheduleParam = {
            workOrgCd: state.workOrgCd,
            intervalCd: state.intervalCd,
            sdate: state.sYmd,
            edate: state.eYmd,
            stdYmd: state.stdYmd,
            dayGubunCd: state.dayGubunCd,
            timeCd: state.scheduleTimeCd,
            note: state.reason,
        };
    },
    SET_SEARCH_WORK_TYPE_CD(state, data) {
        state.searchWorkTypeCd = data;
    },
    SET_WORK_ORG_CD(state, data) {
        state.workOrgCd = data;
    },
    SET_INTERVAL_CD(state, data) {
        state.intervalCd = data;
    },
    SET_STD_YMD(state, data) {
        state.stdYmd = data;
    },
    SET_DAY_GUBUN_CD(state, data) {
        state.dayGubunCd = data;
    },
    SET_WORK_ORG_NM(state, data) {
        state.workOrgNm = data;
    },
    SET_WORK_ORG_TIME_LIST(state, data) {
        state.workOrgTimeList = data;
    },
    SET_SCHEDULE_TIME_CD(state, data) {
        state.scheduleTimeCd = data;
    },
    SET_SCHEDULE_TIME_NM(state, data) {
        state.scheduleTimeNm = data;
    },

    // ======================= OTWORK =========================
    SET_OTWORK_PARAM(state) {
        state.otworkParam = {
            reqTimeCd: state.reqTimeCd,
            workYmd: state.workYmd,
            workWeek: state.workWeek,
            restHour: state.restHour,
            inoutYn: state.inoutYn,
            alterYmd: state.alterYmd,
            alterWeek: state.alterWeek,
            alterGntCd: state.alterGntCd,
            reason: state.reason,
            applYmd: state.applYmd,
            reqSHm: state.reqSHm,
            reqEHm: state.reqEHm,
            requestHour: state.requestHour,
        };
    },
    SET_REQ_TIME_CD(state, data) {
        state.reqTimeCd = data;
    },
    SET_ALTVAC_APPL_STATUS(state, data) {
        state.altvacApplStatus = data;
    },
    SET_ALTER_GNT_NM(state, data) {
        state.alterGntNm = data;
    },
    SET_WORK_YMD(state, data) {
        state.workYmd = data;
    },
    SET_WORK_WEEK(state, data) {
        state.workWeek = data;
    },
    SET_HOL_YN(state, data) {
        state.holYn = data;
        if (data === 'N') {
            state.reqTimeCd = '';
            state.alterYmd = '';
        }
    },
    // 연장근무 신청 사전(B)/사후(A)
    SET_APPL_GUBUN(state, data) {
        // 사후 일때만 출퇴근 반영
        state.applGubun = data;
        state.inoutYn = data === 'A' ? 'Y' : 'N';
    },

    // 출퇴근시간
    SET_IN_OUT(state, data) {
        state.inOut = data;
        if (data.inOut !== null && data.inOut !== '|') {
            const inOut = data.inOut.split('|');
            state.reqSHm = inOut[0];
            state.reqEHm = inOut[1];
        } else if (data.stdHm !== null) {
            const stdHm = data.stdHm.split('|');
            state.reqSHm = stdHm[0];
            state.reqEHm = stdHm[1];
        } else {
            state.reqSHm = '';
            state.reqEHm = '';
        }
    },
    // 제외 휴게시간
    SET_REST_HOUR(state, data) {
        state.restHour = data;
    },
    // 출퇴근시간 반영 여부 값
    SET_IN_OUT_YN(state, data) {
        state.inoutYn = data;
    },
    // 대체휴가 정보
    SET_ALTER_YMD(state, data) {
        state.alterYmd = data;
    },
    SET_ALTER_WEEK(state, data) {
        state.alterWeek = data;
    },
    SET_ALTER_GNT_CD(state, data) {
        state.alterGntCd = data;
    },
    //
    // ======================= PLAN =======================

    SET_PLAN_PARAM(state, data) {
        state.planParam = {
            gntCd: state.gntCd.code,
            sYmd: state.sYmd,
            eYmd: state.eYmd !== undefined ? state.eYmd : data.eYmd,
        };
    },
    // ======================= VACATION =======================

    SET_VACATION_PARAM(state, data) {
        state.vacationParam = {
            baseCnt: state.gntCd.baseCnt,
            maxCnt: state.gntCd.maxCnt,
            gntCd: state.gntCd.code,
            gntGubunCd: state.gntGubunCd,
            sYmd: state.sYmd,
            eYmd: state.eYmd !== undefined ? state.eYmd : data.eYmd,
            reason: state.reason,
            holDay: state.holDay,
            closeDay: state.closeDay,

            applYmd: state.applYmd,
            applYmdWeek: state.applYmdWeek,
            holWorkYmd: state.holWorkYmd,
            holWorkYmdCombo: state.holWorkYmdCombo,
            sYmdWeek: state.sYmdWeek,
            eYmdWeek: state.eYmdWeek,
            reqSHm: state.reqSHm,
            reqEHm: state.reqEHm,
            requestHour: state.requestHour,
        };
    },
    SET_GNT_GUBUN_CD(state, data) {
        state.gntGubunCd = data;
    },
    SET_GNT_CD(state, data) {
        state.gntCd = data;
    },
    SET_S_YMD_WEEK(state, data) {
        state.sYmdWeek = data;
    },
    SET_E_YMD_WEEK(state, data) {
        state.eYmdWeek = data;
    },
    /*
     * 전체일수/적용일수 적용
     * 적용일수 = 전체일수 - 휴일
     */
    SET_CLOSE_DAY(state, holidayMapData) {
        var holDay = holidayMapData.holDay;
        if (state.halfYn === 'N') {
            state.holDay = holDay;
            state.closeDay = holDay - holidayMapData.holidayCnt;
        } else if (state.halfYn === 'Y') {
            // 반차휴가
            state.holDay = '0.5';
            state.closeDay = '0.5';
        } else {
            // 반반차
            state.holDay = '0.25';
            state.closeDay = '0.25';
        }
    },
    SET_CLOSE_DAY_DATA(state, data) {
        state.closeDay = data;
    },
    // 반차 여부
    SET_HALF_YN(state) {
        const reqUseType = state.gntCd.requestUseType;
        if (reqUseType === 'AM' || reqUseType === 'PM') {
            state.halfYn = 'Y';
        } else if (reqUseType === 'QT1' || reqUseType === 'QT4') {
            state.halfYn = 'HY';
        } else if (state.gntGubunCd === '11') {
            state.halfYn = 'N';
        } else {
            state.halfYn = 'N';
        }
    },
    SET_ALTER_VACATION(state, data) {
        state.alterVacation = data;
    },
    SET_APPL_YMD_WEEK(state, data) {
        state.applYmdWeek = data;
    },
    SET_HOL_WORK_YMD(state, data) {
        state.holWorkYmd = data;
    },
    SET_HOL_WORK_YMD_COMBO(state, data) {
        state.holWorkYmdCombo = data;
    },

    // ======================= CANCEL =========================
    // 취소신청시 추가옵션화면 조회용 state 셋팅
    SET_VACATION_STATE(state, map) {
        state.sYmd = map.sYmd;
        state.eYmd = map.eYmd;
        state.reqSHm = map.reqSHm;
        state.reqEHm = map.reqEHm;
        state.gntGubunCd = map.gntGubunCd;
        state.requestHour = map.requestHour;
    },
    SET_SEARCH_BF_APPL_SEQ(state, data) {
        state.searchBfApplSeq = data;
    },

    /** 전체 초기화 */
    RESET_APPLICATION_STATE(state) {
        // ======================= COMMON =========================
        state.appMenu = {}; // 선택한 신청서 메뉴 정보
        state.reason = '';
        state.applYmd = '';
        state.reqSHm = '';
        state.reqEHm = '';
        state.requestHour = '';
        state.sYmd = '';
        state.eYmd = '';
        state.sYmdWeek = '';
        state.eYmdWeek = '';
        state.holDay = ''; // 전체일수
        state.closeDay = ''; // 적용일수
        state.workYmd = '';
        state.workWeek = '';

        state.fileList = [];
        state.reasonFlag = '';
        // ======================= ATTEND =======================
        state.attendParam = {}; // 보상휴가 기본 파라미터
        state.bfShm = '';
        state.bfEhm = '';
        // ======================= REWARD =======================
        state.rewardParam = {}; // 보상휴가 기본 파라미터
        state.rewardList = [];
        state.useRewardList = []; // 사용한 보상휴가 목록
        state.reqTime = 0;
        // ======================= SCHEDULE =======================
        state.scheduleParam = {}; // 근무스케줄 기본 파라미터
        state.searchWorkTypeCd = '';
        state.workOrgCd = ''; // 근무유형 코드
        state.intervalCd = ''; // 근무주기
        state.stdYmd = '';
        state.dayGubunCd = '';
        state.scheduleTimeCd = ''; // 변경한 근무시간코드

        state.workOrgNm = '';
        state.workOrgTimeList = [];
        state.scheduleTimeNm = '';
        // ======================= OTWORK =========================
        state.otworkParam = {}; // 연장근무 기본 파라미터
        state.reqTimeCd = '';
        state.restHour = '';
        state.inoutYn = 'Y';
        state.alterYmd = '';
        state.alterWeek = '';
        state.alterGntCd = '';

        state.altvacApplStatus = 'N'; // 대체휴가자동신청 여부 및 신청상태 (N / 11~99)
        state.alterGntNm = '';
        state.holYn = 'N'; // 휴일여부
        state.applGubun = ''; // A: 사후, B: 사전
        state.inOut = '|'; // 출퇴근 시간
        // ======================= VACATION =======================
        state.vacationParam = {}; // 근태 기본 파라미터
        state.alterVacation = {}; // 선택한 휴일 근무일 정보
        state.gntCd = {}; // 근태명
        state.gntGubunCd = '';
        state.halfYn = 'N'; // 반차 여부
        state.restCnt = ''; // 잔여일수
        state.applYmdWeek = '';
        state.holWorkYmd = ''; // 대체휴일
        state.holWorkYmdCombo = '';
        // ======================= CANCEL =======================
        state.searchBfApplSeq = ''; // 기존 신청서 seq
        state.applCd = '';
    },

    SET_VACCINATION_PARAM(state, data) {
        state.vaccinationParam = {
            ssnEnterCd: data.ssnEnterCd,
            searchApplCd: data.searchApplCd,
            searchApplSabun: data.searchApplSabun,
            searchApplSeq: data.searchApplSeq,
            searchApplYmd: dayjs().format('YYYYMMDD'),
            searchApplName: data.ssnName,
            authPg: 'A', // A신청, R결제
            pathSeq: data.pathSeq,
            applStatusCd: '31', //수신처리중
            fileSeq: data.fileSeq,
            procExecYn: data.procExecYn,
            etc01: data.etc01,
            etc02: data.etc02,
            etc03: data.etc03,
            etc04: data.etc04,
            etc05: data.etc05,
            //appls: data.appls,
            //inusers: data.inusers,
            realAmnt: data.realAmnt,
            applAmnt: data.applAmnt,
            famRshipCd: data.famRshipCd,
            tgtName: data.tgtName,
            applTypeCd: '10', //본인신청
            schClsfiCd: data.schClsfiCd,
        };
    },

    SET_EDUSAPP_PARAM(state, data) {
        state.edusAppParam = {
            ssnEnterCd: data.ssnEnterCd,
            searchApplCd: data.searchApplCd,
            searchApplSabun: data.searchApplSabun,
            searchApplSeq: data.searchApplSeq,
            searchApplYmd: dayjs().format('YYYYMMDD'),
            searchApplName: data.ssnName,
            authPg: 'A', // A신청, R결제
            pathSeq: data.pathSeq,
            applStatusCd: '31', //수신처리중
            fileSeq: data.fileSeq,
            procExecYn: data.procExecYn,
            etc01: data.etc01,
            etc02: data.etc02,
            etc03: data.etc03,
            etc04: data.etc04,
            etc05: data.etc05,
            applAmnt: data.applAmnt,
            tgtName: data.tgtName,
            applTypeCd: '10', //본인신청
            tgtBirthYmd: data.tgtBirthYmd,
            genderCd: data.genderCd,
            schlYyCd: data.schlYyCd,
            tgtQtCd: data.tgtQtCd,
            ssnSabun: data.ssnSabun,
            schlNm: data.schlNm,
            payAmntSum: data.payAmntSum,
            maxAmnt: data.maxAmnt,
            schClsfiCd: data.schClsfiCd,
        };
    },

    SET_LEAABS_PARAM(state, data) {
        state.leaAbsParam = {
            ssnEnterCd: data.ssnEnterCd,
            searchApplCd: data.searchApplCd,
            searchApplSabun: data.searchApplSabun,
            searchApplSeq: data.searchApplSeq,
            searchApplYmd: dayjs().format('YYYYMMDD'),
            searchApplName: data.ssnName,
            authPg: 'A', // A신청, R결제
            pathSeq: data.pathSeq,
            applStatusCd: '31', //수신처리중
            fileSeq: data.fileSeq,
            procExecYn: data.procExecYn,
            etc01: data.etc01,
            etc02: data.etc02,
            etc03: data.etc03,
            etc04: data.etc04,
            etc05: data.etc05,
            applAmnt: data.applAmnt,
            tgtName: data.tgtName,
            applTypeCd: '10', //본인신청
            refSdate: data.refSdate,
            refEdate: data.refEdate,
            returnYmd: data.returnYmd,
            famCd: data.famCd,
            famNm: data.famNm,
            refReason: data.refReason,
            remainDaysBefore: data.remainDaysBefore,
            usedDaysBefore: data.usedDaysBefore,
            caDays: data.caDays,
            applCd: data.applCd,
            famSeq: data.famSeq,
            staYmd: data.staYmd,
            tmpRestEndPlanYmd: data.tmpRestEndPlanYmd,
            reinstPlanYmd: data.reinstPlanYmd,
            searchApplSeq2: data.searchApplSeq2,
            orgTmpRestEndPlanYmd: data.orgTmpRestEndPlanYmd,
            orgReinstPlanYmd: data.orgReinstPlanYmd,
            orgNote: data.orgNote,
            note: data.note,
            orgFamNm: data.orgFamNm,
            orgSabun: data.orgSabun,
            updStaYmd: data.updStaYmd,
        };
    },

    SET_HOL_REPLACE_PARAM(state, data) {
        state.holReplaceParam = {
            ssnEnterCd: data.ssnEnterCd,
            searchApplCd: data.searchApplCd,
            searchApplSabun: data.searchApplInSabun,
            searchApplSeq: data.searchApplSeq,
            searchApplYmd: data.searchApplYmd,
            searchApplName: data.ssnName,
            authPg: 'A', // A신청, R결제
            pathSeq: '',
            applStatusCd: '31', //수신처리중
            fileSeq: data.fileSeq,
            procExecYn: data.procExecYn,
            etc01: data.etc01,
            etc02: data.etc02,
            etc03: data.etc03,
            etc04: data.etc04,
            etc05: data.etc05,
            reqHm: data.reqHm,
            reqSHm: data.reqSHm,
            reqEHm: data.reqEHm,
            reqTimeCd: data.reqTimeCd,
            reqTime: data.reqTime,
            addRestTimeCd: data.addRestTimeCd,
            restTime: data.restTime,
            addRestTime: data.addRestTime,
            replaceHm: data.replaceHm,
            replaceSHm: data.replaceSHm,
            replaceEHm: data.replaceEHm,
            replaceTimeCd: data.replaceTimeCd,
            replaceTime: data.replaceReqTime,
            replaceAddRestTimeCd: data.replaceAddRestTimeCd,
            replaceRestTime: data.replaceRestTime,
            replaceAddRestTime: data.replaceAddRestTime,
            replaceYmd: data.replaceYmd,
            workYmd: data.workYmd,
            workOrgCd: data.workOrgCd,
            workOrgNm: data.workOrgNm,
            replacePeriod: data.replacePeriod,
            note: data.note,
            bfTimeCd: data.bfTimeCd,
            bfTimeNm: data.bfTimeNm,
            startDate: data.startDate,
            endDate: data.endDate,
            replaceBfTimeCd: data.replaceBfTimeCd,
            replaceBfTimeNm: data.replaceBfTimeNm,
            getBfTimeGb: data.getBfTimeGb,
            replaceWorkOrgCd: data.replaceWorkOrgCd,
            applGubun: data.applGubun,
            replaceGubun: data.replaceGubun,
        };
    },

    SET_HOL_REPLACE_CANCEL_PARAM(state, data) {
        state.holReplaceCancelParam = {
            ssnEnterCd: data.ssnEnterCd,
            searchApplCd: data.searchApplCd,
            searchApplSabun: data.searchApplInSabun,
            searchApplSeq: data.searchApplSeq,
            searchApplYmd: data.searchApplYmd,
            searchApplName: data.ssnName,
            authPg: 'A', // A신청, R결제
            pathSeq: '',
            applStatusCd: '31', //수신처리중
            fileSeq: data.fileSeq,
            procExecYn: data.procExecYn,
            etc01: data.etc01,
            etc02: data.etc02,
            etc03: data.etc03,
            etc04: data.etc04,
            etc05: data.etc05,
            sYmd: data.sYmd,
            bApplSeq: data.bApplSeq,
            reqReason: data.reqReason,
        };
    },

    SET_RECERT_PARAM(state, data) {
        state.reCertParam = {
            ssnEnterCd: data.ssnEnterCd,
            searchApplCd: data.searchApplCd,
            searchApplSabun: data.searchApplInSabun,
            searchApplSeq: data.searchApplSeq,
            searchApplYmd: data.searchApplYmd,
            searchApplName: data.ssnName,
            authPg: 'A', // A신청, R결제
            pathSeq: '',
            applStatusCd: '31', //수신처리중
            fileSeq: data.fileSeq,
            procExecYn: data.procExecYn,
            etc01: data.etc01,
            etc02: data.etc02,
            etc03: data.etc03,
            etc04: data.etc04,
            etc05: data.etc05,
            codeNm: data.codeNm,
            applCd: data.applCd,
            address: data.address,
            period: data.period,
            etc: data.note,
            purpose: data.purpose,
            purposeCd: data.purposeCd,
            submitOffice: data.submitOffice,
            reqYy: data.reqYy,
            sYmd: data.sYmd,
            eYmd: data.eYmd,
            emailAddr: data.emailAddr,
        };
    },

    SET_WORK_SCHEDULE_TIME_PARAM(state, data) {
        state.workScheduleTimeParam = {
            ssnEnterCd: data.ssnEnterCd,
            searchApplCd: data.searchApplCd,
            searchApplSabun: data.searchApplInSabun,
            searchApplSeq: data.searchApplSeq,
            searchApplYmd: data.searchApplYmd,
            searchApplName: data.ssnName,
            authPg: 'A', // A신청, R결제
            pathSeq: '',
            applStatusCd: '31', //수신처리중
            fileSeq: data.fileSeq,
            procExecYn: data.procExecYn,
            etc01: data.etc01,
            etc02: data.etc02,
            etc03: data.etc03,
            etc04: data.etc04,
            etc05: data.etc05,
            workGrpCd: data.workGrpCd,
            workOrgCd: data.workOrgCd,
            intervalCd: data.intervalCd,
            dayGubunCd: data.dayGubunCd,
            ymd: data.ymd,
            note: data.note,
            phoneNo: data.phoneNo,
            reasonCd: data.reasonCd,
            searchSYmd: data.searchSYmd,
            searchEYmd: data.searchEYmd,
            saveListData: data.saveListData,
        };
    },

    SET_VACATIONS_PARAM(state, data) {
        state.vacationsParam = {
            ssnEnterCd: data.ssnEnterCd,
            searchApplCd: data.searchApplCd,
            searchApplSabun: data.searchApplInSabun,
            searchApplSeq: data.searchApplSeq,
            searchApplYmd: data.searchApplYmd,
            searchApplName: data.ssnName,
            authPg: 'A', // A신청, R결제
            pathSeq: '',
            applStatusCd: '31', //수신처리중
            fileSeq: data.fileSeq,
            procExecYn: data.procExecYn,
            etc01: data.etc01,
            etc02: data.etc02,
            etc03: data.etc03,
            etc04: data.etc04,
            etc05: data.etc05,

            gntNm: data.gntNm,
            gntCd: data.gntCd,

            restCnt: data.restCnt,
            restCntTime: data.restCntTime,

            occYmd: data.occYmd,
            sYmd: data.sYmd,
            eYmd: data.eYmd,

            dayTypeNm: data.dayTypeNm,
            dayType: data.dayType,

            holDay: data.holDay,
            closeDay: data.closeDay,

            reqSHm: data.reqSHm,
            reqEHm: data.reqEHm,
            requestHour: data.requestHour,

            useTargetAnnual: data.useTargetAnnual,
            useTargetAnnualNm: data.useTargetAnnualNm,

            baseCnt: data.baseCnt,
            maxCnt: data.maxCnt,

            srcYy: data.srcYy,
            srcGntCd: data.srcGntCd,
            srcUseSYmd: data.srcUseSYmd,
            srcUseEYmd: data.srcUseEYmd,

            subSabunNm: data.subSabunNm,
            subSabun: data.subSabun,
            gntReqReson: data.gntReqReson,
            gntGubunCd: data.gntGubunCd,
            isCancelVacation: data.isCancelVacation,
            searchBApplSeq: data.searchBApplSeq,
            code: data.code,
        };
    },
};